import axios from 'axios';

// 创建请求拦截器，自动添加认证token
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    
    if (token) {
      // 添加认证头
      config.headers['x-auth-token'] = token;
      
      // 有些API可能使用这种格式
      config.headers['Authorization'] = `Bearer ${token}`;
      
      console.log(`请求拦截器: 添加认证token到 ${config.url}`);
    } else {
      console.log(`请求拦截器: 未找到token，请求 ${config.url} 可能会失败`);
    }
    
    return config;
  },
  error => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 创建响应拦截器，处理认证错误
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      console.error('认证失败，可能需要重新登录');
      // 可以在这里添加自动重定向到登录页面的逻辑
      // window.location = '/login';
    }
    return Promise.reject(error);
  }
);

export default axios; 